import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(QUERY).matches;

/**
 * OS 의 '동작 줄이기' 설정을 boolean 으로 읽어요.
 * GSAP 안에서는 `gsap.matchMedia()` 를 쓰고, 렌더 분기에 값이 필요할 때만 이 훅을 써요.
 * SSR 은 안 쓰지만 `useSyncExternalStore` 의 서버 스냅샷은 false(=애니메이션 있음)로 둬요.
 */
export const usePrefersReducedMotion = () =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
